export default __webpack_public_path__ + "static/media/heroku.8a2420a7.svg";